import { Injectable } from '@angular/core';

import { RepositoryService } from '@get/services/repository';
import { GeneratedSocieteComposantRattachementApiService } from './societe-composant-rattachement-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class SocieteComposantRattachementApiService extends GeneratedSocieteComposantRattachementApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
